import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=5bcc65e8&scoped=true&"
import script from "./IsLoading.vue?vue&type=script&lang=js&"
export * from "./IsLoading.vue?vue&type=script&lang=js&"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=5bcc65e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc65e8",
  null
  
)

export default component.exports